export default () => {
  return (Math.random() * (100.0 - 1.0 + 1.0) + 1.0).toFixed(1) + 'k';
};
